<template>
  <div class="form-login">
    <div class="form-login__alert">
      <p class="alerts alerts-errors text-center" v-if="error">
        {{ error }}
      </p>
    </div>

    <div class="form-login__content">
      <ValidationObserver v-slot="ob">
        <Form
          novalidate
          :valid="true"
          :loading="loading"
          @submit="ob.handleSubmit(submit)"
        >
          <template>
            <ValidationProvider name="Email" rules="required|email" v-slot="v">
              <FormGroup label="Email" for="LoginEmail" :vee-errors="v.errors">
                <InputVue
                  type="email"
                  name="email"
                  id="LoginEmail"
                  v-model="email"
                  :vee="v"
                ></InputVue>
              </FormGroup>
            </ValidationProvider>

            <ValidationProvider
              mode="aggressive"
              name="Password"
              rules="required"
              v-slot="v"
            >
              <FormGroup
                label="Password"
                for="LoginPassword"
                :vee-errors="v.errors"
              >
                <InputVue
                  type="password"
                  name="password"
                  id="LoginPassword"
                  v-model="password"
                  :vee="v"
                ></InputVue>
              </FormGroup>
            </ValidationProvider>
          </template>

          <FormSubmit
            slot="footer"
            class="p-4"
            :disabled="loading || !ob.passed"
            >Accedi</FormSubmit
          >
        </Form>
      </ValidationObserver>
      <small class="my-4 block"
        >Hai dimenticato la password?
        <a
          href="#"
          @click.prevent="$emit('forgotPassword', true)"
          class="font-bold"
          >Clicca qui</a
        ></small
      >
    </div>
  </div>
</template>

<script>
// import LOGIN from '../graphql/Login.gql'
import PROFILE from '../graphql/Profile.gql'
import { onLogin } from '../vue-apollo'
import Form from '@/components/Form.vue'
import FormGroup from '@/components/FormGroup.vue'
import FormSubmit from '@/components/FormSubmit.vue'
import InputVue from '@/components/fields/InputVue.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import axios from 'axios'

export default {
  components: {
    Form,
    FormGroup,
    FormSubmit,
    InputVue,
    ValidationObserver,
    ValidationProvider,
  },

  data() {
    return {
      loading: false,
      error: this.$route.query['session-expired']
        ? 'Your session has expired, please login again'
        : '',
      email: '',
      password: '',
    }
  },

  methods: {
    async submit() {
      this.loading = true
      this.error = ''

      try {
        const { data } = await axios.post('/.netlify/functions/login', {
          email: this.email,
          password: this.password,
          tenant: this.$route.params.tenant,
        })
        await onLogin(this.$apollo.provider.clients.defaultClient, data.token)
        this.$store.commit('user/setToken', data.token)
      } catch (err) {
        this.error = 'Invalid credentials'
        this.loading = false
        return
      }

      try {
        await this.fetchProfile()
      } catch {
        this.error = 'Invalid credentials'
        this.loading = false
        return
      }

      this.$router.push({
        name: 'Home',
        params: { tenant: this.$route.params.tenant },
      })
    },

    async fetchProfile() {
      try {
        const res = await this.$apollo.query({
          query: PROFILE,
        })

        await this.$store.dispatch('user/saveProfile', {
          profile: res.data.me,
          tenant: this.$route.params.tenant,
        })
      } catch (err) {
        console.log(err)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.form-login {
  @include e(footer) {
    @apply mt-4;
  }
}
</style>
